import React, { useEffect } from 'react';

const ThankYou = () => {
  useEffect(() => {
    document.title = 'Thank You | Bularis Tech';
  }, []);

  return (
    <div style={{ textAlign: 'center', padding: '4rem' }}>
      <h1>Thank You!</h1>
      <p>Your message has been sent successfully. We'll get back to you shortly.</p>
    </div>
  );
};

export default ThankYou;